import React, { useEffect } from 'react';

export default function useDraggableScroll<T extends HTMLElement>(
  reference: React.RefObject<T>,
  options?: {
    mouseDownCondition: (target: HTMLElement) => boolean;
  }
) {
  useEffect(() => {
    const element = reference.current as HTMLElement;
    let pos: { left: number; x: number } = { left: 0, x: 0 };
    let moving = false;
    // element.style.cursor = 'grab';
    const mouseDownHandler = (evt: MouseEvent) => {
      if (
        options &&
        typeof options.mouseDownCondition === 'function' &&
        !options.mouseDownCondition(evt.target as HTMLElement)
      ) {
        return;
      }
      if (evt.button === 0 && element?.scrollWidth > element?.clientWidth) {
        // element.style.cursor = 'grabbing';
        moving = true;
        pos = {
          left: element?.scrollLeft || 0,
          x: evt.clientX,
        };
      }
    };

    const mouseMoveHandler = (evt: MouseEvent) => {
      const dx = evt.clientX - pos.x;
      // Scroll the element
      if (moving) {
        element.scrollLeft = pos.left - dx;
      }
    };
    const mouseUpHandler = () => {
      // element.style.cursor = 'grab';
      moving = false;
    };
    element?.addEventListener('mousedown', mouseDownHandler);
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
    return () => {
      element?.removeEventListener('mousedown', mouseDownHandler);
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reference]);
}
